<script setup lang="ts">
  import { useGlobalSettingsStore } from '@/stores/GlobalSettings.store'

  const globalSettingsStore = useGlobalSettingsStore()
  await callOnce(() => globalSettingsStore.init())

  const { ogImage } = storeToRefs(globalSettingsStore)

  useSeoMeta({
    ogImage: () => (ogImage.value?.src ? ogImage.value.src + '/m/1200x630' : undefined),
    twitterImage: () => (ogImage.value?.src ? ogImage.value.src + '/m/1200x630' : undefined)
  })
</script>

<template>
  <slot />
</template>
